module.exports = __webpack_public_path__ + "static/media/menno.a9791b60.jpg";